import $ from 'jquery';

export default function () {
  $(document).ready(() => {
    // Open Search Button
    const searchButton = document.querySelector('#opensearch');

    // Add OnClick to Open Search Button
    searchButton.addEventListener('click', () => {
      const searchButtonStatus = JSON.parse($('button#opensearch').attr('aria-expanded'));

      if (searchButtonStatus === true) {
        closeSearch();
      } else if (searchButtonStatus === false) {
        openSearch();
      }
    });

    // Close Search Button
    const menuSearchButton = document.querySelector('#closesearch');

    // Add OnClick to Close Search Button
    menuSearchButton.addEventListener('click', () => {
      const menuSearchButtonStatus = JSON.parse($('button#closesearch').attr('aria-expanded'));

      if (menuSearchButtonStatus === true) {
        closeSearch();
      } else if (menuSearchButtonStatus === false) {
        openSearch();
      }
    });

    // Open the Search Menu, toggle icon
    function openSearch() {
      // Make sure the Nav Menu is hidden
      $('#mySidenav').css({
        width: '0',
        visibility: 'hidden',
      });

      $('button#opensearch')
        .html($('div#closeSearchContent').html())
        .removeClass('menuClosed')
        .addClass('menuOpen')
        .attr('aria-expanded', 'true')
        .attr('aria-label', 'Open Search Menu');

      // Show Search Menu
      $('#mySearch').css({
        height: '100%',
        visibility: 'visible',
      });

      $('#main').attr({
        'aria-hidden': 'true',
        visibility: 'hidden',
      });

      const mainLinks = document.getElementById('main').getElementsByTagName('a');
      for (let i = 0; i < mainLinks.length; i++) {
        mainLinks[i].setAttribute('tabindex', '-1');
      }

      const mainButtons = document.getElementById('main').getElementsByTagName('button');
      for (let j = 0; j < mainButtons.length; j++) {
        mainButtons[j].setAttribute('disabled', 'true');
      }

      setTimeout(() => {
        $('#closesearch').focus();
      }, 500);

      // $('button#opensearch')
      //   .html($('div#closeSearchContent').html())
      //   .removeClass('menuClosed')
      //   .addClass('menuOpen')
      //   .attr('aria-expanded', 'true')
      //   .attr('aria-label', 'Close Search Menu');
      $('footer').css('visibility', 'hidden');
      $('body').css({ overflow: 'hidden' });

      searchFocusIn();
    }

    // Lock focus inside the Nav Menu
    function searchFocusIn() {
      // Element to return to when the user escapes
      const elementBeforeFocus = document.activeElement;

      const menu = document.getElementById('mySearch');

      // Make child elements tab-able, mark first and last elements for loop
      const focusElements = menu.querySelectorAll('input, button');

      const focusList = Array.prototype.slice.call(focusElements);

      const firstTab = focusList[0];
      const lastTab = focusList[focusList.length - 1];

      focusElements.forEach((elem) => {
        elem.addEventListener('keydown', (e) => {
          trapTabKey(e);
        });
      });

      document.getElementById('opensearch').addEventListener('keydown', (e) => {
        trapTabKey(e);
      });

      document.getElementById('closesearch').addEventListener('keydown', (e) => {
        trapTabKey(e);
      });

      function trapTabKey(key) {
        if (key.keyCode === 9) {
          if (key.shiftKey) {
            if (document.activeElement === firstTab) {
              key.preventDefault();
              lastTab.focus();
            }
          } else if (document.activeElement === lastTab) {
            key.preventDefault();
            firstTab.focus();
          }
        }

        if (key.keyCode === 27) {
          elementBeforeFocus.focus();
        }
      }

      firstTab.focus();
    }

    // Close the Search Menu, toggle icon
    function closeSearch() {
      $('#mySearch').css({
        height: '0',
        visibility: 'hidden',
      });

      $('#main')
        .attr({
          visibility: 'visible',
          'margin-left': '0',
        })
        .removeAttr('aria-hidden');

      $('body').css('background-color', 'white');

      const mainLinks = document.getElementById('main').getElementsByTagName('a');
      for (let i = 0; i < mainLinks.length; i++) {
        mainLinks[i].removeAttribute('tabindex');
      }

      const mainButtons = document.getElementById('main').getElementsByTagName('button');
      for (let j = 0; j < mainButtons.length; j++) {
        mainButtons[j].removeAttribute('disabled');
      }

      $('button#opensearch')
        .html($('div#openSearchContent').html())
        .removeClass('menuOpen')
        .addClass('menuClosed')
        .attr('aria-expanded', 'false')
        .attr('aria-label', 'Open Search Menu')
        .focus();
      $('body').css({ overflow: 'visible' });
      $('footer').css('visibility', 'visible');
    }
  });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/search.js